import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk'; // Import Redux Thunk middleware

// Import your slice reducers here
import userSlice from './userSlice';
import { default as loadingSlice, loadingMiddleware } from './loadingSlice';
import knownDataSlice from './knownDataSlice';
import knownArrangementsSlice from './knownArrangementsSlice';
import shownDataSlice from './shownDataSlice';
import busesSlice from './busesSlice';
import driversSlice from './driversSlice';
import inquerySlice from './inquerySlice';
import foodPackagesSlice from './foodPackagesSlice';
import privateNotesSlice from './privateNotesSlice';
import jobEventsSlice from './jobEventsSlice';

const store = configureStore({
  reducer: {
    // Add your slice reducers here
    user: userSlice,
    loading: loadingSlice,
    knownData: knownDataSlice,
    shownData: shownDataSlice,
    knownArrangements: knownArrangementsSlice,
    buses: busesSlice,
    drivers: driversSlice,
    inquery: inquerySlice,
    foodPackages: foodPackagesSlice,
    privateNotes: privateNotesSlice,
    jobEvents: jobEventsSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([ thunk, loadingMiddleware ]),
});

export default store;
